var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBSliders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-sliders",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-sliders1",
    serifid: "iconB-sliders"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8,13c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-2,0l0,6c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-6l-2,0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l6,0Zm3,-6l0,-4c-0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,4l2,0c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-6,0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l2,0Zm11,8c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1l-2,0l0,4c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-4l-2,0c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1l6,0Zm-16,-5c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-7c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,7Zm7,11c-0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1l0,-9c-0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,9Zm7,-9c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-9c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBSliders);
export default __webpack_public_path__ + "static/media/iconB-sliders.2cedb0b76df8a4bff3e20d5e42a00f99.svg";
export { ForwardRef as ReactComponent };